import React, { useEffect, useRef, useState } from 'react';
import { InputComponent } from '../InputComponent';
import { ButtonComponent } from '../ButtonComponent';
import { convertToArabicNumbers, convertToNumbersInArabic, GetAppText, ValidationErrors } from "../../../utils";

import "../../../App.css"
import { useSelector,useDispatch } from "react-redux";
import { modalHandler } from "../../../store/slices/modalSlice";
import { useNavigate } from 'react-router-dom';
import { apiRoutes } from '../../../apis/routes';
import { getRequest, postRequest } from '../../../apis/methods';
import SvgComponent from '../SvgComponent';
import Dropdown from '../Dropdown';
import MosqueDropdown from "../MosqueDropdown"
const QuickDonate = ({ data }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [selectedAmount, setSelectedAmount] = useState(''); // track selected amount

  const language = useSelector((state) => state.language.value);
  const [isCustomAmount, setIsCustomAmount] = useState(false);

  const[addloading,setAddLoading]=useState(false)
  const[donateloading,setDonateLoading]=useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
const InpRef=useRef('')
  const handleAddtoCart = async (item) => {

    // Prevent multiple submissions
  if (addloading) return; 
  // Prevent multiple submissions


    // const payload = {
    //   itemable_type: "category",
    //   itemable_id:selectedCategory,
  
    //   price: selectedAmount  
    // };
       const englishPhoneNumber = convertToArabicNumbers(selectedAmount);
   
       const number = Number(englishPhoneNumber);


    const payload = {
      cart_type:"CART",
      is_edit:false,
      items: [
          {
              id:selectedCategory,
              type:"CATEGORY",
              price: number
          }
      ]}
  

  
  if(selectedAmount && selectedCategory){
    setAddLoading(true)
 
  
    try {
      const response = await postRequest(apiRoutes.add_cart, payload); // Replace with your endpoint
    
      if (response.status === "success") { 
        setAddLoading(false)
     
        let error = '';
        if (
          response?.message?.includes(ValidationErrors.addCartItem.added)
        ) {
          error = GetAppText('added_cart');
        
        } 
        else if (
          response?.message?.includes(ValidationErrors.addCartItem.updated)
        ) {
          error = GetAppText('updated_cart');
         
        } 

        dispatch(modalHandler({ type: "toast", msg: error}));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
  
    
   
      } else {
        setAddLoading(false)
        let error=""
        if (
          response?.data?.message?.includes(ValidationErrors.addCartItem.limit_error)
        ) {
          // error = `${GetAppText('limit_price_cart')} ${item?.itemable?.remaining_goal_amount?.toLocaleString()}.`;
          error = GetAppText('limit_price_cart');
     
        } 
        else {
          // error = GetAppText('something_went_wrong');
          error= response?.data?.message
        }
        // setIsAddModal(false)
        dispatch(modalHandler({ type: "toastError", msg: error}));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
     
       
      }
    } 
    catch (error) {
      console.error('Error fetching data:', error);
    }
  

  
  }
    else{
        setAddLoading(false)
     
        dispatch(modalHandler("fieldError"));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])

    }
  
  };

const handleDonate=async()=>{

  // Prevent multiple submissions
if (donateloading) return; 
// Prevent multiple submissions
 
const englishPhoneNumber = convertToArabicNumbers(selectedAmount);
   
const number = Number(englishPhoneNumber);

  const payload = {
    cart_type:"DONATION",
    is_edit:false,
    items: [
        {
            id:selectedType==1? selectedAreaValues?.id: selectedCategory,
            type:selectedVal,
            price: number
        }
    ]
  }

if(selectedAmount &&( selectedCategory || selectedAreaValues)){
  setDonateLoading(true)

try {
  const response = await postRequest(apiRoutes.add_cart, payload); // Replace with your endpoint


  if (response.status === "success") { 
    setDonateLoading(false)
  
    dispatch(modalHandler(""))
    // dispatch(donationHandler("Donate"))
    // localStorage.setItem('Donate',true)
    navigate(`/checkout/donation`);
  

  } else {
    setDonateLoading(false)
    // setIsAddModal(false)
    let error=""
    if (
      response?.data?.message?.includes(ValidationErrors.addCartItem.limit_error)
    ) {
      error = GetAppText('limit_price_cart');
 
    } 
    else {
      // error = GetAppText('something_went_wrong');
      error= response?.data?.message
    }
    // setIsAddModal(false)
    dispatch(modalHandler({ type: "toastError", msg: error}));
    setTimeout(()=>{
        dispatch(modalHandler(""));
      },[500])

   
  }
} 
catch (error) {
  console.error('Error fetching data:', error);
}

}

else{
  setDonateLoading(false)

  dispatch(modalHandler("fieldError"));
  setTimeout(()=>{
      dispatch(modalHandler(""));
    },[500])

}

}

  // Handle quick amount selection
  const handleQuickAmountClick = (amount) => {
    InpRef.current.focus();
    setIsCustomAmount(false); // Disable custom amount
    setSelectedAmount(amount); // Set the selected predefined amount
  };

  // Handle custom amount input
  // const handleCustomAmountChange = (e) => {
  //   setIsCustomAmount(true); // Indicate that user is typing custom amount
  //   setSelectedAmount(e.target.value); // Set custom input value as the selected amount
  // };


  const arabicDigits = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  const englishDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  // const handlePriceChange = (e) => {
  //   let value = e.target.value;
  
  //   // If language is Arabic, convert Arabic digits back to English for processing
  //   // if (language === "_ar") {
  //   //   value = value
  //   //     .split("")
  //   //     .map((char) => {
  //   //       const index = arabicDigits.indexOf(char);
  //   //       return index > -1 ? englishDigits[index] : char;
  //   //     })
  //   //     .join("");
  //   // }
  
  //   // Allow numeric characters and a single decimal point, limit to 8 digits before the decimal
  //   const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\.)(?=.*\.)/g, "");
  
  //   // Restrict to maximum 8 digits before the decimal point
  //   const parts = numericValue.split(".");
  //   if (parts[0].length > 8) parts[0] = parts[0].slice(0, 8);

  //   // Limit to 2 digits after the decimal
  // if (parts.length > 1) {
  //   parts[1] = parts[1].slice(0, 2);
  // }
  
  //   const formattedValue = parts.join(".");
  
  //   // if (language === "_ar") {
  //   //   // Convert English digits to Arabic digits for display
  //   //   const arabicValue = formattedValue
  //   //     .split("")
  //   //     .map((digit) => (digit === "." ? "." : arabicDigits[Number(digit)]))
  //   //     .join("");
  
  //   //     setSelectedAmount(arabicValue);
  //   // } else {
  //     setSelectedAmount(formattedValue);
  //   // }
  // };


// const handlePriceChange = (e) => {
//   let value = e.target.value;

//   // Convert Arabic-Indic digits (٠١٢٣٤٥٦٧٨٩) to English digits (0–9)
//   const arabicToEnglishMap = {
//     "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
//     "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9"
//   };
//   value = value.replace(/[٠-٩]/g, d => arabicToEnglishMap[d]);

//   // Allow numeric characters and a single decimal point
//   let numericValue = value.replace(/[^0-9.]/g, "").replace(/(\.)(?=.*\.)/g, "");

//   // Restrict to max 8 digits before decimal
//   const parts = numericValue.split(".");
//   if (parts[0].length > 8) parts[0] = parts[0].slice(0, 8);

//   // Limit to 2 digits after the decimal
//   if (parts.length > 1) {
//     parts[1] = parts[1].slice(0, 2);
//   }

//   const formattedValue = parts.join(".");

//   // Set the final value
//   setSelectedAmount(formattedValue);
// };


const handlePriceChange = (e) => {
  let value = e.target.value;

  // ✅ Convert Arabic (٠١٢٣٤٥٦٧٨٩) and Urdu (۰۱۲۳۴۵۶۷۸۹) digits to English (0–9)
  const digitMap = {
    // Arabic-Indic
    "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
    "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
    // Urdu (Eastern Arabic-Indic)
    "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
    "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9"
  };

  // Replace all Arabic/Urdu digits with English digits
  value = value.replace(/[٠-٩۰-۹]/g, d => digitMap[d]);

  // ✅ Allow only numbers and a single decimal point
  let numericValue = value.replace(/[^0-9.]/g, "").replace(/(\.)(?=.*\.)/g, "");

  // ✅ Restrict to max 8 digits before decimal
  const parts = numericValue.split(".");
  if (parts[0].length > 8) parts[0] = parts[0].slice(0, 8);

  // ✅ Limit to 2 digits after the decimal
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2);
  }

  const formattedValue = parts.join(".");

  // ✅ Update state
  setSelectedAmount(formattedValue);
};

  const handleCustomAmountChange = (e) => {
    let value = e.target.value;
  
    // If language is Arabic, convert Arabic digits back to English for processing
    if (language === "_ar") {
      value = value
        .split("")
        .map((char) => {
          const index = arabicDigits.indexOf(char);
          return index > -1 ? englishDigits[index] : char;
        })
        .join("");
    }
  
    // Remove non-numeric characters and limit to 8 digits
    const numericValue = value.replace(/[^0-9]/g, "");

      if (language === "_ar") {
        // Convert English digits to Arabic digits for display
        const arabicValue = numericValue
          .split("")
          .map((digit) => arabicDigits[Number(digit)])
          .join("");
        
          setSelectedAmount(arabicValue);
      } 
      else {
        setSelectedAmount(numericValue);
      }
    
  };

    const [selectedType, setSelectedType] = useState(1);
    const [selectedVal, setSelectedVal] = useState('QUICK_MOSQUE');
    const [selectedAreaParam, setSelectedAreaParam] = useState([]);
    const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
     const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const typeData=[

{id:1,title:"Mosques",title_ar:"المساجد",val:"QUICK_MOSQUE"},
{id:2,title:"Projects",title_ar:"المشاريع",val:"CATEGORY"},

]

  const [selectedGovernet, setSelectedGovernet] = useState("");
  const [selectedAreaValues, setSelectedAreaValues] = useState("");
  const [areas, setAreas] = useState([]);

const buttonRef = useRef(null); // <-- for the toggle button
const dropdownRef = useRef(null);
const handleClickOutside = (event) => {
  if (
    dropdownRef.current &&
    !dropdownRef.current.contains(event.target) &&
    buttonRef.current &&
    !buttonRef.current.contains(event.target)
  ) {
    setIsDropdownOpen(false);
  }
};

useEffect(() => {
console.log("dataaaa=====",data)

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

 const info = useSelector((state) => state.info.value);
  const handleSelectGovernet = (value) => {
    // Update selectedValues with selected/unselected options
    // setSelectedGovernet(value);
    // setSelectedAreaParam([]);
      setSelectedGovernet((prevValue) => {
    // Check if the option is already selected
    const isSelected = prevValue?.id === value.id;

    if (isSelected) {
      // Deselect: Clear the selection
      setSelectedAreaParam([]);
      return null;
    } 

      else {
        if (value.id === 0) {
          // Clicked "All"
          setSelectedAreaParam([]);
          return null;
        } else {
          // Select a new governorate
          setSelectedAreaParam([]);
          return value;
        }
      }

      // Select: Set the new option
      // setSelectedAreaParam([]);
      // return value;
    }
  );



    
    // setIsDropdownOpen4(false)
  };
  const handler2 = () => {

    setIsDropdownOpen2(!isDropdownOpen2);
  };
  const handleSelectArea = (value) => {
    // Update selectedValues with selected/unselected options
    console.log("handleSelectArea",value)
    setSelectedAreaValues(value)
    setIsDropdownOpen(false)
    // setSelectedAreaValues((prevSelected) => {
    //   const isSelected = prevSelected.some((item) => item.id === value.id);

    //   // Update selected IDs array
    //   setSelectedAreaParam((prevIds) => {
    //     if (isSelected) {
    //       // Remove unselected option's ID from categoryParams array
    //       return prevIds.filter((id) => id !== value.id);
    //     } else {
    //       // Add selected option's ID to categoryParams array
    //       return [...prevIds, value.id];
    //     }
    //   });

    //   // Return updated selected values
    //   if (isSelected) {
    //     // Unselect the option
    //     return prevSelected.filter((item) => item.id !== value.id);
    //   } else {
    //     // Select the option
    //     return [...prevSelected, value];
    //   }
    // });

  };
  useEffect(()=>{
getArea()
  },[])

    const getArea = async () => {
      let data = {};
      if (selectedGovernet) {
        data["governorate_id "] = '';
      }
      try {
        const response = await getRequest(apiRoutes.get_quick_donate); // Replace with your endpoint
  
        if (response.status === "success") {
        // const filtered = response?.data?.data?.filter(item => item.is_quick_donation === 1);
          setAreas(response?.data);
         
          // dispatch(infoHandler(response?.data));
        }
      } catch (error) {
        console.error("Error fetching device info:", error);
      }
    };
  const handler = () => {

    // setIsDropdownOpen(!isDropdownOpen);
setIsDropdownOpen(prev => !prev);


  };


  return (
    <div>
      <div className='space-y-3 sm:h-[420px] h-[400px] sm:!mb-3  !mb-1 overflow-y-auto custom-scrollbar px-1 sm:!pb-3 !pb-1'
      onClick={()=>{setIsDropdownOpen(false)}}
      >

<div className='space-y-3 pr-1 pb-4'>
       <div className={`${language === '_ar' ? 'text-right' : 'text-left'} text-F16 font-semibold text-white`}>
          {GetAppText('donationProjects')}
        </div>
                  <div className={`flex -custom-mobile-wrap ${language === '_ar' ? 'flex-row-reverse' : ''} sm:gap-4 gap-2 `}>
          {typeData?.map((item, index) => (
            <div
              key={index}
              onClick={() =>{ setSelectedType(item.id);
                setSelectedVal(item?.val)}
              } // Set selected category
              className={`w-full h-[48px] ${language === '_ar' ? 'flex-row-reverse' : ''}  flex items-center
                sm:px-[24px] px-[12px] gap-2 border sm:text-F16 text-F13 rounded-md border-white cursor-pointer
                ${selectedType === item.id ? 'bg-white text-black' : 'text-white'}`} // Change background when selected
            >
                  <SvgComponent
                      name={
                        selectedType === item.id
                          ? "CheckboxFill"
                          : "CircleCheckboxUnfill"
                      }
                      className={`sm:w-6 sm:h-6  w-5 h-5`}
                      fill={"none"}
                    />
                    <div>
              {language === '_ar' ? item?.title_ar : item?.title}
              </div>
            </div>
          ))}
        </div>
</div>

{selectedType===1?<div className='space-y-3'>
       <div className={`${language === '_ar' ? 'text-right' : 'text-left'} text-F16 font-semibold text-white`}>
          {GetAppText('donate_search')}
        </div>
     
                    <div  onClick={(e) => e.stopPropagation()} className="relative w-full">
                      <div  ref={buttonRef}>
                    <ButtonComponent
                      onClick={handler}

 title={
                        !selectedAreaValues
                          ? (language == "_ar" ? "اختر المسجد" : "Choose Mosque") // if null, show "All"
                          : language == "_ar"
                          ? selectedAreaValues?.title_ar
                          : selectedAreaValues?.title
                      }

               
                      svg={
                        <SvgComponent
                          name={"ChevronDown"}
                          // className={`w-2.5 h-2`}
                          className={`w-2.5 h-2 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : 'rotate-0'}`}
                          stroke={"#1B1C1E"}
                          fill={"none"}
                        />
                      }
                      styles={"py-2 px-4 whitespace-nowrap w-full bg-white justify-between sm:!text-F16 !text-F14 !normal-case "}
                      type="secondary_transparent"
                    />
</div>
                    <Dropdown
                      // area={true}
                      mosque={true}
                      mainStyle={"!h-52 !w-full !z-50"}
                      handleSelect={handleSelectArea}
                      isOpen={isDropdownOpen}
                      options={areas}
                      selectedValues={selectedAreaValues}
                      setIsDropdownOpen={setIsDropdownOpen}
                      isDropOutside={false}
                    
                    />
                  </div>
</div>
:
<div className='space-y-3'>

        <div className={`${language === '_ar' ? 'text-right' : 'text-left'} text-F16 font-semibold text-white`}>
          {GetAppText('select_category')}
        </div>

        {/* Categories Section */}
        <div
        dir={language === "_ar" ? "rtl" : "ltr"}
        className={`sm:flex grid grid-cols-2 ${language === '_ar' ? 'flex-row-reverse' : ''} sm:flex-wrap   sm:gap-4 gap-2`}>
          {data?.categories?.filter(item =>item?.bank_account_id && item.show_in_web === 1)?.map((item, index) => (
            <div
             
              key={index}
              onClick={() => setSelectedCategory(item.id)} // Set selected category
              className={`sm:w-[152px] w-full h-[48px]  flex items-center justify-center 
                border
                 sm:text-F16 text-F13 rounded-md border-white cursor-pointer
                ${selectedCategory === item.id ? 'bg-white text-black' : 'text-white'}`} // Change background when selected
            >
              <div className='line-clamp-1 sm:px-0 px-4'
              dir={language === "_ar" ? "rtl" : "ltr"}
              >
              {language === '_ar' ? item?.title_ar : item?.title}
              </div>
            </div>
          ))}
        </div>
</div>}
        {/* Amounts Section */}
        <div className={`${language === '_ar' ? 'text-right' : 'text-left'} pt-6 text-F16 font-semibold text-white`}>
          {GetAppText('choose_amount')}
        </div>
        <div 
         dir={language === "_ar" ? "rtl" : "ltr"}
        className={`sm:flex grid grid-cols-3 ${language === '_ar' ? 'flex-row-reverse' : ''} sm:flex-wrap sm:gap-4 gap-2 `}>
          {data?.quick_amounts?.map((item, index) => (
            <div
              key={index}
              onClick={() => handleQuickAmountClick(item.amount)} // Set selected amount
              className={`sm:w-[152px]  w-full h-[48px] gap-1 font-bold ${language === '_ar' ? 'flex-row-reverse' : ''} flex items-center justify-center border sm:text-F16 text-F13 rounded-md border-white cursor-pointer
                ${selectedAmount === item.amount ? 'bg-white text-black' : ' text-white'}`} // Change background when selected
            >
              <div>
                {/* {language==="_ar"? convertToNumbersInArabic(item?.amount): item?.amount} */}
                {item?.amount}

              </div>
              <div>{GetAppText('bhd')}</div>
            </div>
          ))}
        </div>

   <div className='sm:hidden sm:!pt-0 !pt-4'>

        <div
          className='w-full  flex-nowrap '
          style={{
            display: 'flex',
            flexDirection: language === '_ar' ? 'row-reverse' : 'row',
            gap: 10,
          }}
        >
                <InputComponent
      ref={InpRef}
            title="donation_amount"
            value={ selectedAmount } 
                  // value={language==="_ar"?convertToNumbersInArabic(selectedAmount):convertToArabicNumbers(selectedAmount)}
            // Clear input if quick amount is selected

            onChange={(e)=>{  e.stopPropagation();  handlePriceChange(e)}}
            // onChange={handleCustomAmountChange} // Update custom amount
            type="text"
          />
          {/* <ButtonComponent loading={addloading} disabled={addloading || donateloading} onClick={()=>{handleAddtoCart(data)}} styles={"!w-full !py-2.5 !text-F18 !bg-[#697B84]"} title={GetAppText('add_cart')} type="primary" /> */}
          <ButtonComponent loading={donateloading} disabled={addloading || donateloading} onClick={()=>{handleDonate(data)}} styles={"!w-[152px] !py-2.5 !text-F18"} title={GetAppText('donate_now')} />
        </div>
      </div>

      </div>

      {/* Input and Buttons Section */}
      <div className='sm:block hidden'>

        <div
          className='w-full  flex-nowrap '
          style={{
            display: 'flex',
            flexDirection: language === '_ar' ? 'row-reverse' : 'row',
            gap: 10,
          }}
        >
                <InputComponent
      ref={InpRef}
            title="donation_amount"
            value={ selectedAmount } 
                  // value={language==="_ar"?convertToNumbersInArabic(selectedAmount):convertToArabicNumbers(selectedAmount)}
            // Clear input if quick amount is selected

            onChange={(e)=>{  e.stopPropagation();  handlePriceChange(e)}}
            // onChange={handleCustomAmountChange} // Update custom amount
            type="text"
          />
          {/* <ButtonComponent loading={addloading} disabled={addloading || donateloading} onClick={()=>{handleAddtoCart(data)}} styles={"!w-full !py-2.5 !text-F18 !bg-[#697B84]"} title={GetAppText('add_cart')} type="primary" /> */}
          <ButtonComponent loading={donateloading} disabled={addloading || donateloading} onClick={()=>{handleDonate(data)}} styles={"!w-[152px] !py-2.5 !text-F18"} title={GetAppText('donate_now')} />
        </div>
      </div>
    </div>
  );
};

export default QuickDonate;
